import React from 'react';
import uniqueId from 'lodash/uniqueId';
import './styles.css';
import BasicButton from '../BasicButton';
import EmailRequirementsItem from './components/EmailRequirementsItem';

const EmailRequirements = props => {
  const {
    data,
    actions: { onAdd, onEdit, onRemove, onView },
  } = props;

  return (
    <div className="email-requirements">
      <div className="email-requirements__header">
        <h5 className="email-requirements__subtitle">Email Requirements</h5>

        <div className="email-requirements__button">
          <BasicButton
            btnWidth={130}
            btnHeight={35}
            btnFontWeight={600}
            btnText="Add"
            btnArrow={false}
            btnBg="#fff"
            btnHoverBg="#f40"
            controlFunc={onAdd}
          />
        </div>
      </div>
      <div className="email-requirements__content">
        {data.map(item => (
          <EmailRequirementsItem
            data={item}
            actions={{
              onEdit,
              onRemove,
              onView,
            }}
            key={uniqueId()}
          />
        ))}
      </div>
    </div>
  );
};

export default EmailRequirements;
